import {
  NonRetriableError,
  OfflineError,
  withRequestRetry,
  DEFAULT_REQUEST_TIMEOUT,
} from './DataExtraction';
import {
  BASELINE_CHARACTERISTIC_RESULTS_ROUTE,
  tokenizeRoute,
} from 'query/routes';
import { getStudyId } from 'query/study/Study';
import { BaselineCharacteristicResult } from 'types';

export const updateBaselineCharacteristicResult = async (
  baseline_characteristic_id: string | number,
  result: BaselineCharacteristicResult,
  onError?: (error: Error) => Error
) => {
  return withRequestRetry(
    () =>
      _updateBaselineCharacteristicResultRequest(
        baseline_characteristic_id,
        result
      ),
    onError
  );
};

const _updateBaselineCharacteristicResultRequest = async (
  baseline_characteristic_id: string | number,
  result: BaselineCharacteristicResult
) => {
  if (!navigator.onLine)
    throw new OfflineError('No network connection detected');

  const url = tokenizeRoute(BASELINE_CHARACTERISTIC_RESULTS_ROUTE, {
    review_study_id: getStudyId(),
    baseline_characteristic_id,
  });

  return fetch(url.toString(), {
    method: 'PUT',
    body: JSON.stringify(result),
    headers: { 'Content-Type': 'application/json' },
    signal: (AbortSignal as any).timeout(DEFAULT_REQUEST_TIMEOUT),
  }).then((response) => {
    if (!response.ok) throw new NonRetriableError(String(response.status));

    return response.json();
  });
};
